import type { ReactNode } from "react";
import { Link } from "react-router";
import { Wordmark } from "@/components/brand/Brand";

/**
 * 로그인,가입 화면의 공통 틀 , 가운데 선 한 줄 폼(max-w-form).
 * 부제는 할 말이 있을 때만 쓴다. 맨 아래 법적 문구는 화면이 바꿔 쓸 수 있다.
 */
export function AuthShell({ title, sub, children, footer, legal }: { title: string; sub?: string; children: ReactNode; footer: ReactNode; legal?: ReactNode }) {
  return (
    <main className="auth-main">
      <div className="w-full max-w-form">
        <Link to="/login" className="inline-flex" aria-label="홈으로">
          <Wordmark />
        </Link>
        <h1 className="mt-page text-title font-extrabold tracking-tight text-ink">{title}</h1>
        {sub && <p className="mt-inline text-body leading-relaxed text-ink-muted">{sub}</p>}
        <div className="mt-page">{children}</div>
        <p className="auth-footer">{footer}</p>
        <p className="auth-legal">
          {legal ?? (
            <>
              계속하면 <Link to="/terms">이용약관</Link>과 <Link to="/privacy">개인정보처리방침</Link>에 동의하는 것으로 봅니다.
            </>
          )}
        </p>
      </div>
    </main>
  );
}

/** next 는 사용자가 만질 수 있다 , 외부로 튕겨 보낼 수 없게 내부 경로만 통과시킨다 */
export function safeNext(raw: string | null | undefined, fallback = "/app"): string {
  if (!raw || !raw.startsWith("/") || /^\/[/\\]/.test(raw)) return fallback;
  return raw;
}
